import Card from './Card.vue';
import { NAME } from './constants';
import { router } from './router';
import { apiProvider } from './api';

export const NahradniDily = {
	name: NAME,
	router,
	apiProvider,
	components: {
		Card,
	},
};
